// hooks
import useSubscriptions from 'src/hooks/useSubscriptions';
import { StyledAccountBadge } from './styles';
import { DoubleCubeIcon } from 'src/theme/overrides/CustomIcons';
import { AppTooltip } from 'src/components';
// ----------------------------------------------------------------------

const AccountBadge = () => {
  const { userOnFreePlan, trialExpiresMessage, isPremiumUser, activateYourPlansMessage } =
    useSubscriptions();

  if (isPremiumUser) {
    return <StyledAccountBadge size="small" avatar={<DoubleCubeIcon />} label="Premium" color="secondary" />
  } else if (userOnFreePlan) {
    return <StyledAccountBadge label="Free" size="small" />;
  } else if (isPremiumUser) {
    return <StyledAccountBadge size="small" avatar={<DoubleCubeIcon />} label="Premium" color="secondary" />;
  } else if (trialExpiresMessage) {
    return <StyledAccountBadge label="Trial" color="primary" variant="outlined" size="small" />;
  } else if (activateYourPlansMessage) {
    return (
      <StyledAccountBadge
        size="small"
        avatar={<DoubleCubeIcon />}
        label="Subscribe today"
        color="secondary"
      />
    );
  } else {
    return null;
  }
}

interface FeatureBadgeProps {
  status?: 'trial' | 'inactive';
  small?: boolean;
  label?: string;
}
const FeatureBadge = ({ status = 'trial', small, label }: FeatureBadgeProps) => {
  return (
    <AppTooltip
      disableHoverListener = {status === 'trial'}
      placement="top"
      title="Upgrade your plan to view your premium features"
    >
      <StyledAccountBadge
        small={small?.toString()}
        avatar={<DoubleCubeIcon />}
        label={label ? label : small ? '' : status === 'trial' ? 'Premium feature' : 'Subscribe today'}
        variant={'filled'}
        color={'secondary'}
      />
    </AppTooltip>
  )
}

export { AccountBadge, FeatureBadge };